var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// form-field.ts
import "@adornis/base/utilTypes";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element";
import "@adornis/chemistry/chemistry-lite-element";
import { BehaviorController } from "@adornis/chemistry/controllers/behavior-controller";
import { event } from "@adornis/chemistry/decorators/event";
import { property, state } from "lit/decorators.js";
var FormField = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.value = new BehaviorController(this, void 0);
    this.disabled = false;
    this.error = void 0;
  }
};
__decorateClass([
  event,
  state()
], FormField.prototype, "value", 2);
__decorateClass([
  property({ type: Boolean })
], FormField.prototype, "disabled", 2);
__decorateClass([
  property({ reflect: true })
], FormField.prototype, "error", 2);
export {
  FormField
};
